import React from 'react';
import * as R from 'ramda';
import { Icon } from 'antd';
import { connect } from 'react-redux';

const tabHOC = (reducer) =>
  (WrappedComponent) => {

    const mapStateToProps = (state, ownProps) => {
      const keyWindow = ownProps.keyWindow;

      if (state[reducer][keyWindow]) {
        return {
          keyWindow,
          entities: R.indexBy(
            R.prop('id'),
            R.pathOr([], [reducer, keyWindow, 'ids'], state).map(id => state[reducer].byId[id])
          ),
          drafts: R.indexBy(
            R.prop('id'),
            R.pathOr([], [reducer, keyWindow, 'ids'], state).map(id => state[reducer].draftsById[id])
          ),
          isLoading: R.pathOr(false, [reducer, keyWindow, 'isLoading'], state),
          isInitialized: true,
        };
      }
      return {
        isInitialized: false,
      };
    };


    // ...and returns another component...
    class Wrapper extends React.Component {
      render() {
        if (this.props.isInitialized) {
          return (<WrappedComponent {...this.props} />);
        }

        return (
          <div
            style={{ height: '50px', lineHeight: '50px', background: '#fff', textAlign: 'center' }}
          >
            <Icon type="loading" />
          </div>
        );
      }
    }

    return connect(mapStateToProps)(Wrapper);
  }
;

export default tabHOC;
